export const PRESCREEN_BRIEFING_COPY = {
  beforeYouStartHeading: 'Before you start',
  durationTitle: 'About 8 minutes',
  durationDetail: 'Complete it whenever works for you.',
  contextTitle: 'Start with the context',
  contextDetail: 'You’ll hear about the company and role before you begin.',
  questionsTitle: 'Ask as you go',
  questionsDetail: 'You can ask questions at any time.',
  whoReviewsHeading: 'Who reviews your intro',
  recruiterReviewDetail: 'Reviews the transcript of your answers.',
  hiringDecisionDetail: 'Every hiring decision is made by a hiring manager.',
  cta: 'Setup audio & Start!',
  dataSharing: 'Learn more about how we handle your information in our',
  privacyLink: 'Privacy policy',
} as const;

export interface PrescreenBriefingStrength {
  summary: string;
  explanation: string;
}

export interface PrescreenBriefingHeading {
  leading: string;
  firstName?: string;
  trailing: string;
}

export const PRESCREEN_BRIEFING_FALLBACK_STRENGTH: Readonly<PrescreenBriefingStrength> =
  Object.freeze({
    summary: 'Your background looks relevant',
    explanation:
      'We saw experience in your profile that could be a good fit for this role and would like to learn more.',
  });

export function getStrongMatchHeading(
  firstName: string,
): PrescreenBriefingHeading {
  const normalizedFirstName = firstName.trim();

  return normalizedFirstName
    ? {
        leading: 'We found you, ',
        firstName: normalizedFirstName,
        trailing: '. You’re a strong match for this one',
      }
    : {
        leading: 'We found you — you’re a strong match for this one',
        trailing: '',
      };
}

export function getPrescreenBriefingStrengths(
  strengths: readonly PrescreenBriefingStrength[] | null | undefined,
): readonly PrescreenBriefingStrength[] {
  return strengths && strengths.length > 0
    ? strengths
    : [PRESCREEN_BRIEFING_FALLBACK_STRENGTH];
}

export function getRecruiterReviewTitle(firstName: string) {
  return `${firstName}, your Finlay recruiter`;
}
